const fonts = {
  heading: "'Noto Sans JP', sans-serif",
  body: "'Noto Sans JP', sans-serif",
};
export default fonts;
